import React from 'react';
import { InternalError } from 'components';

class ErrorBoundary extends React.Component {
  state = { error: false, text: "" };

  componentDidCatch(error, info) {
    console.error(error, info);
    this.setState({ error: true, text: error.message });
  }

  render() {
    if(this.state.error) return <InternalError code={this.state.text} />;
    return this.props.children;
  }
}

export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.jsx